export function cn(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

function resolveApiUrl(): string {
  const raw = import.meta.env.VITE_API_URL;

  if (!raw) {
    throw new Error("VITE_API_URL is not set. Add it to your .env file ");
  }

  return raw.replace(/\/$/, "");
}

export const API_URL = resolveApiUrl();
